import { Type } from '@angular/core';

export class AddComponent {
  constructor(public component: Type<any>, public _id: any) {}
}
